(function () {
  var sections = document.querySelectorAll(".agenturen-page");

  if (!sections.length) {
    return;
  }

  document.body.classList.add("agenturen-page-active");

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var compactMotion = window.matchMedia("(max-width: 749px)").matches;

  function revealImmediately(section) {
    section.querySelectorAll("[data-reveal]").forEach(function (element) {
      element.classList.add("is-visible");
    });
  }

  function markInitiallyVisible(elements) {
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var cutoff = viewportHeight * (compactMotion ? 1.04 : 0.92);

    elements.forEach(function (element) {
      var rect = element.getBoundingClientRect();

      if (rect.top <= cutoff) {
        element.classList.add("is-visible");
      }
    });
  }

  function formatValue(value, element) {
    var prefix = element.dataset.prefix || "";
    var suffix = element.dataset.suffix || "";
    var decimals = Number(element.dataset.decimals || 0);
    var number = new Intl.NumberFormat("de-DE", {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    }).format(value);

    return prefix + number + suffix;
  }

  function setFinalValue(element) {
    var endValue = Number(element.dataset.countup || 0);
    element.textContent = formatValue(endValue, element);
  }

  function animateValue(element) {
    if (element.dataset.animated === "true") {
      return;
    }

    element.dataset.animated = "true";

    if (reduceMotion) {
      setFinalValue(element);
      return;
    }

    var endValue = Number(element.dataset.countup || 0);
    var duration = Number(element.dataset.duration || 1400);
    var startTime = null;

    function step(timestamp) {
      if (!startTime) {
        startTime = timestamp;
      }

      var progress = Math.min((timestamp - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = endValue * eased;
      var decimals = Number(element.dataset.decimals || 0);

      if (decimals === 0) {
        current = Math.round(current);
      } else {
        current = Number(current.toFixed(decimals));
      }

      element.textContent = formatValue(current, element);

      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        setFinalValue(element);
      }
    }

    window.requestAnimationFrame(step);
  }

  sections.forEach(function (section) {
    var contactForm = section.querySelector("#AgenturenContactForm");

    if (contactForm && !contactForm.dataset.shopifyCaptcha) {
      contactForm.setAttribute("data-shopify-captcha", "true");
    }

    var revealElements = Array.prototype.slice.call(section.querySelectorAll("[data-reveal]"));
    revealElements.forEach(function (element, index) {
      var stepDelay = compactMotion ? 18 : 36;
      var maxDelay = compactMotion ? 70 : 180;
      element.style.setProperty("--reveal-delay", Math.min(index * stepDelay, maxDelay) + "ms");
    });

    var countElements = section.querySelectorAll("[data-countup]");

    if (!("IntersectionObserver" in window) || reduceMotion) {
      revealImmediately(section);
      countElements.forEach(setFinalValue);
      return;
    }

    markInitiallyVisible(revealElements);
    section.classList.add("agenturen-page--motion-ready");

    var revealObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          return;
        }

        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      });
    }, {
      threshold: compactMotion ? 0.04 : 0.08,
      rootMargin: compactMotion ? "0px 0px 2% 0px" : "0px 0px -4% 0px"
    });

    revealElements.forEach(function (element) {
      if (element.classList.contains("is-visible")) {
        return;
      }

      revealObserver.observe(element);
    });

    var countObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          return;
        }

        animateValue(entry.target);
        observer.unobserve(entry.target);
      });
    }, {
      threshold: compactMotion ? 0.3 : 0.4
    });

    countElements.forEach(function (element) {
      countObserver.observe(element);
    });
  });
})();
